// Logica derivata garanzie (DATA_MODEL.md §5). Condivisa client/server così
// il countdown è coerente ovunque.
import type { WarrantyStatus } from './types';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

/** Aggiunge `months` mesi a una data ISO, restituisce ISO (solo data). */
export function addMonths(isoDate: string, months: number): string {
  const d = new Date(isoDate + 'T00:00:00Z');
  const day = d.getUTCDate();
  d.setUTCMonth(d.getUTCMonth() + months);
  // Gestisce overflow (es. 31 gen + 1 mese): se il giorno cambia, vai a fine mese precedente.
  if (d.getUTCDate() < day) d.setUTCDate(0);
  return d.toISOString().slice(0, 10);
}

/** expires_at = purchased_at + warranty_months. */
export function computeExpiresAt(purchasedAt: string, warrantyMonths: number): string {
  return addMonths(purchasedAt, warrantyMonths);
}

/** Giorni interi tra oggi (UTC) ed expires_at. Negativo se scaduta. */
export function daysLeft(expiresAt: string, now: Date = new Date()): number {
  const exp = new Date(expiresAt + 'T00:00:00Z').getTime();
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.round((exp - today) / MS_PER_DAY);
}

/** Frazione di tempo trascorso (0–1). */
export function progress(purchasedAt: string, expiresAt: string, now: Date = new Date()): number {
  const start = new Date(purchasedAt + 'T00:00:00Z').getTime();
  const end = new Date(expiresAt + 'T00:00:00Z').getTime();
  if (end <= start) return 1;
  const frac = (now.getTime() - start) / (end - start);
  return Math.min(1, Math.max(0, frac));
}

/** expired se days<0; expiring se 0..30; altrimenti active. */
export function warrantyStatus(days: number): WarrantyStatus {
  if (days < 0) return 'expired';
  if (days <= 30) return 'expiring';
  return 'active';
}
